<template>
    <div class="list-header">
        <h1 class="color-primary page-title">{{ title }}</h1>

        <b-button variant="primary" @click="onClick">{{
            buttonActionText
        }}</b-button>
    </div>
</template>

<script>
import { noMarginMixin } from '@/mixins'

export default {
    name: 'HeaderBar',
    props: {
        title: String,
        buttonActionText: String,
        noMargin: {
            type: Boolean,
            default: false,
        },
    },
    mixins: [noMarginMixin],
    methods: {
        onClick() {
            this.$emit('click', true)
        },
    },
}
</script>

<style lang="sass" scoped>
.list-header
    background: #ffffff
    height: auto
    z-index: 1
    width: 100%
    padding: 15px 50px
    display: flex
    align-items: center
    justify-content: space-between
    .page-title
        font-size: 24px
        color: #6f6f6f
        margin: 0
    button
        font-size: 12px
        width: 120px
</style>
